import { createRoot } from 'react-dom/client';
import '@fontsource/montserrat/latin-400.css';
import '@fontsource/montserrat/latin-500.css';
import '@fontsource/montserrat/latin-600.css';
import '@fontsource/montserrat/latin-700.css';
import '@fontsource/montserrat/latin-800.css';
import './theme/tokens.css';
import './theme/app.css';
import { App } from './App';

createRoot(document.getElementById('root')!).render(<App />);

// handy for support and automated tests: the builder's own state (nothing secret in it)
import { useStore, commit } from './store/store';
import { preflight } from '@gsb/core';
(window as unknown as { __gsb: unknown }).__gsb = {
  useStore,
  /** a change like any edit (undo step, autosave) */
  commit,
  /** the same checks the panels show (and the server runs when ordering) */
  preflight: () => { const s = useStore.getState(); return s.config ? preflight(s.doc, s.assets, s.config.builder, s.config.pricing as never) : null; }
};
